import React from 'react'
import { Radio } from '../../../shared/components'
import { PaymentMethod } from '../../../shared/types/battery'
import { PixIcon, CreditCardIcon, DebitCardIcon, BoletoIcon } from './CheckoutIcons'
import { CartItem } from '../../../store/modules/cart/types'

interface CheckoutStep2Props {
  selectedPaymentMethod: PaymentMethod | null
  setSelectedPaymentMethod: (method: PaymentMethod) => void
  currentStep: number
  orderId: string | null
  hasAttemptedOrderCreation: React.MutableRefObject<boolean>
  cartState: {
    items: CartItem[]
  }
  shippingAddress: any
  billingAddress: any
  deliveryMethod: 'shipping' | 'pickup' | null
  storeAddress?: {
    street: string
    number: string
    complement?: string
    neighborhood: string
    city: string
    state: string
    zipCode: string
    country: string
  }
  appliedCoupons: Array<{ code: string }>
  calculateSubtotal: () => number
  calculateDiscount: () => number
  calculateShipping: () => number
  calculateTotal: () => number
  setOrderId: (id: string | null) => void
  handles: Record<string, string>
  createOrder: (params: any) => Promise<string | null>
  isCreatingOrder: boolean
  isCampinas: boolean
  scrapPreference: boolean | null
}

export const CheckoutStep2: React.FC<CheckoutStep2Props> = ({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  currentStep,
  orderId,
  hasAttemptedOrderCreation,
  cartState,
  shippingAddress,
  billingAddress,
  deliveryMethod,
  storeAddress,
  appliedCoupons,
  calculateSubtotal,
  calculateDiscount,
  calculateShipping,
  calculateTotal,
  setOrderId,
  handles,
  createOrder,
  isCreatingOrder,
  isCampinas,
  scrapPreference
}) => {
  return (
    <div className={`${handles.formSection}`}>
      <h2 className={`${handles.formTitle} text-xl font-semibold text-gray-900 mb-6`}>
        Método de Pagamento
      </h2>

      <p className="text-gray-600 mb-6">
        Selecione a forma de pagamento. Você poderá preencher os dados na próxima etapa.
      </p>

      <div className={`${handles.paymentMethods} space-y-4`}>
        {[
          { id: PaymentMethod.PIX, name: 'PIX', description: 'Aprovação imediata', icon: <PixIcon /> },
          { id: PaymentMethod.CREDIT_CARD, name: 'Cartão de Crédito', description: 'Parcelamento disponível', icon: <CreditCardIcon /> },
          { id: PaymentMethod.DEBIT_CARD, name: 'Cartão de Débito', description: 'Débito em conta', icon: <DebitCardIcon /> },
          { id: PaymentMethod.BOLETO, name: 'Boleto Bancário', description: 'Vencimento em 3 dias', icon: <BoletoIcon /> }
        ].map(method => (
          <label key={method.id} className={`${handles.paymentMethod} flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors ${selectedPaymentMethod === method.id ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
            }`}>
            <Radio
              name="payment"
              value={method.id}
              checked={selectedPaymentMethod === method.id}
              onChange={async (e) => {
                const newMethod = e.target.value as PaymentMethod
                setSelectedPaymentMethod(newMethod)

                if (newMethod === PaymentMethod.PIX && Number(currentStep) === 3 && !orderId && !isCreatingOrder && !hasAttemptedOrderCreation.current) {
                  console.log('[Checkout] PIX selecionado no step 3, criando pedido imediatamente...')
                  hasAttemptedOrderCreation.current = true

                  const createOrderForPix = async () => {
                    const newOrderId = await createOrder({
                      cartItems: cartState.items,
                      shippingAddress,
                      billingAddress,
                      selectedPaymentMethod: newMethod,
                      deliveryMethod,
                      appliedCoupons,
                      calculateSubtotal,
                      calculateDiscount,
                      calculateShipping,
                      calculateTotal,
                      storeAddress,
                      isCampinas,
                      scrapPreference
                    })

                    if (newOrderId) {
                      console.log('[Checkout] Pedido criado com sucesso, orderId:', newOrderId)
                      setOrderId(newOrderId)
                    } else {
                      console.warn('[Checkout] Falha ao criar pedido para PIX')
                      hasAttemptedOrderCreation.current = false
                    }
                  }

                  void createOrderForPix()
                }
              }}
              className="mr-3 text-blue-600 focus:ring-blue-500"
            />
            <div className={`${handles.paymentIcon} text-2xl mr-4`}>
              {method.icon}
            </div>
            <div className={`${handles.paymentInfo} flex-1`}>
              <div className="font-medium text-gray-900">{method.name}</div>
              <div className="text-sm text-gray-600">{method.description}</div>
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}
